/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import { hot } from 'react-hot-loader/root'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Trees from '../trees/index.js'
import Branches from '../branches/index.js'
import SnowStorm from 'react-snowstorm'

const ARTICLE_ID = '29933338'
const ADDITIONAL_SHARES = 66

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
  }

  render() {
    const dataSet = [
      {
        year: 1931,
        day: 24,
        snowZH: 1
      },
      {
        year: 1931,
        day: 25,
        snowZH: 1
      },
      {
        year: 1931,
        day: 26,
        snowZH: 1
      },
      {
        year: 1932,
        day: 24,
        snowZH: 0
      },
      {
        year: 1932,
        day: 25,
        snowZH: 0
      },
      {
        year: 1932,
        day: 26,
        snowZH: 0
      },
      {
        year: 1933,
        day: 24,
        snowZH: 2
      },
      {
        year: 1933,
        day: 25,
        snowZH: 2
      },
      {
        year: 1933,
        day: 26,
        snowZH: 2
      },
      {
        year: 1934,
        day: 24,
        snowZH: 0
      },
      {
        year: 1934,
        day: 25,
        snowZH: 0
      },
      {
        year: 1934,
        day: 26,
        snowZH: 0
      },
      {
        year: 1935,
        day: 24,
        snowZH: 19
      },
      {
        year: 1935,
        day: 25,
        snowZH: 18
      },
      {
        year: 1935,
        day: 26,
        snowZH: 17
      },
      {
        year: 1936,
        day: 24,
        snowZH: 0
      },
      {
        year: 1936,
        day: 25,
        snowZH: 0
      },
      {
        year: 1936,
        day: 26,
        snowZH: 0
      },
      {
        year: 1937,
        day: 24,
        snowZH: 1
      },
      {
        year: 1937,
        day: 25,
        snowZH: 0
      },
      {
        year: 1937,
        day: 26,
        snowZH: 0
      },
      {
        year: 1938,
        day: 24,
        snowZH: 6
      },
      {
        year: 1938,
        day: 25,
        snowZH: 6
      },
      {
        year: 1938,
        day: 26,
        snowZH: 4
      },
      {
        year: 1939,
        day: 24,
        snowZH: 0
      },
      {
        year: 1939,
        day: 25,
        snowZH: 0
      },
      {
        year: 1939,
        day: 26,
        snowZH: 0
      },
      {
        year: 1940,
        day: 24,
        snowZH: 10
      },
      {
        year: 1940,
        day: 25,
        snowZH: 10
      },
      {
        year: 1940,
        day: 26,
        snowZH: 8
      },
      {
        year: 1941,
        day: 24,
        snowZH: 0
      },
      {
        year: 1941,
        day: 25,
        snowZH: 0
      },
      {
        year: 1941,
        day: 26,
        snowZH: 0
      },
      {
        year: 1942,
        day: 24,
        snowZH: 0
      },
      {
        year: 1942,
        day: 25,
        snowZH: 0
      },
      {
        year: 1942,
        day: 26,
        snowZH: 0
      },
      {
        year: 1943,
        day: 24,
        snowZH: 0
      },
      {
        year: 1943,
        day: 25,
        snowZH: 0
      },
      {
        year: 1943,
        day: 26,
        snowZH: 0
      },
      {
        year: 1944,
        day: 24,
        snowZH: 0
      },
      {
        year: 1944,
        day: 25,
        snowZH: 0
      },
      {
        year: 1944,
        day: 26,
        snowZH: 0
      },
      {
        year: 1945,
        day: 24,
        snowZH: 0
      },
      {
        year: 1945,
        day: 25,
        snowZH: 0
      },
      {
        year: 1945,
        day: 26,
        snowZH: 0
      },
      {
        year: 1946,
        day: 24,
        snowZH: 0
      },
      {
        year: 1946,
        day: 25,
        snowZH: 0
      },
      {
        year: 1946,
        day: 26,
        snowZH: 0
      },
      {
        year: 1947,
        day: 24,
        snowZH: 0
      },
      {
        year: 1947,
        day: 25,
        snowZH: 0
      },
      {
        year: 1947,
        day: 26,
        snowZH: 0
      },
      {
        year: 1948,
        day: 24,
        snowZH: 0
      },
      {
        year: 1948,
        day: 25,
        snowZH: 0
      },
      {
        year: 1948,
        day: 26,
        snowZH: 0
      },
      {
        year: 1949,
        day: 24,
        snowZH: 0
      },
      {
        year: 1949,
        day: 25,
        snowZH: 0
      },
      {
        year: 1949,
        day: 26,
        snowZH: 0
      },
      {
        year: 1950,
        day: 24,
        snowZH: 8
      },
      {
        year: 1950,
        day: 25,
        snowZH: 7
      },
      {
        year: 1950,
        day: 26,
        snowZH: 8
      },
      {
        year: 1951,
        day: 24,
        snowZH: 0
      },
      {
        year: 1951,
        day: 25,
        snowZH: 0
      },
      {
        year: 1951,
        day: 26,
        snowZH: 0
      },
      {
        year: 1952,
        day: 24,
        snowZH: 0
      },
      {
        year: 1952,
        day: 25,
        snowZH: 0
      },
      {
        year: 1952,
        day: 26,
        snowZH: 0
      },
      {
        year: 1953,
        day: 24,
        snowZH: 0
      },
      {
        year: 1953,
        day: 25,
        snowZH: 0
      },
      {
        year: 1953,
        day: 26,
        snowZH: 0
      },
      {
        year: 1954,
        day: 24,
        snowZH: 2
      },
      {
        year: 1954,
        day: 25,
        snowZH: 3
      },
      {
        year: 1954,
        day: 26,
        snowZH: 0
      },
      {
        year: 1955,
        day: 24,
        snowZH: 0
      },
      {
        year: 1955,
        day: 25,
        snowZH: 0
      },
      {
        year: 1955,
        day: 26,
        snowZH: 0
      },
      {
        year: 1956,
        day: 24,
        snowZH: 6
      },
      {
        year: 1956,
        day: 25,
        snowZH: 4
      },
      {
        year: 1956,
        day: 26,
        snowZH: 4
      },
      {
        year: 1957,
        day: 24,
        snowZH: 0
      },
      {
        year: 1957,
        day: 25,
        snowZH: 0
      },
      {
        year: 1957,
        day: 26,
        snowZH: 0
      },
      {
        year: 1958,
        day: 24,
        snowZH: 0
      },
      {
        year: 1958,
        day: 25,
        snowZH: 16
      },
      {
        year: 1958,
        day: 26,
        snowZH: 13
      },
      {
        year: 1959,
        day: 24,
        snowZH: 0
      },
      {
        year: 1959,
        day: 25,
        snowZH: 0
      },
      {
        year: 1959,
        day: 26,
        snowZH: 0
      },
      {
        year: 1960,
        day: 24,
        snowZH: 0
      },
      {
        year: 1960,
        day: 25,
        snowZH: 0
      },
      {
        year: 1960,
        day: 26,
        snowZH: 0
      },
      {
        year: 1961,
        day: 24,
        snowZH: 0
      },
      {
        year: 1961,
        day: 25,
        snowZH: 0
      },
      {
        year: 1961,
        day: 26,
        snowZH: 1
      },
      {
        year: 1962,
        day: 24,
        snowZH: 8
      },
      {
        year: 1962,
        day: 25,
        snowZH: 9
      },
      {
        year: 1962,
        day: 26,
        snowZH: 9
      },
      {
        year: 1963,
        day: 24,
        snowZH: 2
      },
      {
        year: 1963,
        day: 25,
        snowZH: 2
      },
      {
        year: 1963,
        day: 26,
        snowZH: 2
      },
      {
        year: 1964,
        day: 24,
        snowZH: 4
      },
      {
        year: 1964,
        day: 25,
        snowZH: 2
      },
      {
        year: 1964,
        day: 26,
        snowZH: 16
      },
      {
        year: 1965,
        day: 24,
        snowZH: 0
      },
      {
        year: 1965,
        day: 25,
        snowZH: 0
      },
      {
        year: 1965,
        day: 26,
        snowZH: 0
      },
      {
        year: 1966,
        day: 24,
        snowZH: 0
      },
      {
        year: 1966,
        day: 25,
        snowZH: 0
      },
      {
        year: 1966,
        day: 26,
        snowZH: 0
      },
      {
        year: 1967,
        day: 24,
        snowZH: 0
      },
      {
        year: 1967,
        day: 25,
        snowZH: 0
      },
      {
        year: 1967,
        day: 26,
        snowZH: 0
      },
      {
        year: 1968,
        day: 24,
        snowZH: 0
      },
      {
        year: 1968,
        day: 25,
        snowZH: 4
      },
      {
        year: 1968,
        day: 26,
        snowZH: 11
      },
      {
        year: 1969,
        day: 24,
        snowZH: 11
      },
      {
        year: 1969,
        day: 25,
        snowZH: 9
      },
      {
        year: 1969,
        day: 26,
        snowZH: 8
      },
      {
        year: 1970,
        day: 24,
        snowZH: 3
      },
      {
        year: 1970,
        day: 25,
        snowZH: 4
      },
      {
        year: 1970,
        day: 26,
        snowZH: 5
      },
      {
        year: 1971,
        day: 24,
        snowZH: 0
      },
      {
        year: 1971,
        day: 25,
        snowZH: 0
      },
      {
        year: 1971,
        day: 26,
        snowZH: 0
      },
      {
        year: 1972,
        day: 24,
        snowZH: 0
      },
      {
        year: 1972,
        day: 25,
        snowZH: 0
      },
      {
        year: 1972,
        day: 26,
        snowZH: 0
      },
      {
        year: 1973,
        day: 24,
        snowZH: 0
      },
      {
        year: 1973,
        day: 25,
        snowZH: 0
      },
      {
        year: 1973,
        day: 26,
        snowZH: 1
      },
      {
        year: 1974,
        day: 24,
        snowZH: 0
      },
      {
        year: 1974,
        day: 25,
        snowZH: 0
      },
      {
        year: 1974,
        day: 26,
        snowZH: 0
      },
      {
        year: 1975,
        day: 24,
        snowZH: 3
      },
      {
        year: 1975,
        day: 25,
        snowZH: 3
      },
      {
        year: 1975,
        day: 26,
        snowZH: 3
      },
      {
        year: 1976,
        day: 24,
        snowZH: 4
      },
      {
        year: 1976,
        day: 25,
        snowZH: 4
      },
      {
        year: 1976,
        day: 26,
        snowZH: 3
      },
      {
        year: 1977,
        day: 24,
        snowZH: 0
      },
      {
        year: 1977,
        day: 25,
        snowZH: 0
      },
      {
        year: 1977,
        day: 26,
        snowZH: 0
      },
      {
        year: 1978,
        day: 24,
        snowZH: 3
      },
      {
        year: 1978,
        day: 25,
        snowZH: 0
      },
      {
        year: 1978,
        day: 26,
        snowZH: 0
      },
      {
        year: 1979,
        day: 24,
        snowZH: 11
      },
      {
        year: 1979,
        day: 25,
        snowZH: 10
      },
      {
        year: 1979,
        day: 26,
        snowZH: 8
      },
      {
        year: 1980,
        day: 24,
        snowZH: 0
      },
      {
        year: 1980,
        day: 25,
        snowZH: 0
      },
      {
        year: 1980,
        day: 26,
        snowZH: 0
      },
      {
        year: 1981,
        day: 24,
        snowZH: 9
      },
      {
        year: 1981,
        day: 25,
        snowZH: 10
      },
      {
        year: 1981,
        day: 26,
        snowZH: 9
      },
      {
        year: 1982,
        day: 24,
        snowZH: 0
      },
      {
        year: 1982,
        day: 25,
        snowZH: 0
      },
      {
        year: 1982,
        day: 26,
        snowZH: 0
      },
      {
        year: 1983,
        day: 24,
        snowZH: 0
      },
      {
        year: 1983,
        day: 25,
        snowZH: 0
      },
      {
        year: 1983,
        day: 26,
        snowZH: 0
      },
      {
        year: 1984,
        day: 24,
        snowZH: 0
      },
      {
        year: 1984,
        day: 25,
        snowZH: 2
      },
      {
        year: 1984,
        day: 26,
        snowZH: 0
      },
      {
        year: 1985,
        day: 24,
        snowZH: 0
      },
      {
        year: 1985,
        day: 25,
        snowZH: 0
      },
      {
        year: 1985,
        day: 26,
        snowZH: 0
      },
      {
        year: 1986,
        day: 24,
        snowZH: 17
      },
      {
        year: 1986,
        day: 25,
        snowZH: 16
      },
      {
        year: 1986,
        day: 26,
        snowZH: 18
      },
      {
        year: 1987,
        day: 24,
        snowZH: 0
      },
      {
        year: 1987,
        day: 25,
        snowZH: 0
      },
      {
        year: 1987,
        day: 26,
        snowZH: 0
      },
      {
        year: 1988,
        day: 24,
        snowZH: 0
      },
      {
        year: 1988,
        day: 25,
        snowZH: 0
      },
      {
        year: 1988,
        day: 26,
        snowZH: 0
      },
      {
        year: 1989,
        day: 24,
        snowZH: 0
      },
      {
        year: 1989,
        day: 25,
        snowZH: 0
      },
      {
        year: 1989,
        day: 26,
        snowZH: 0
      },
      {
        year: 1990,
        day: 24,
        snowZH: 8
      },
      {
        year: 1990,
        day: 25,
        snowZH: 7
      },
      {
        year: 1990,
        day: 26,
        snowZH: 6
      },
      {
        year: 1991,
        day: 24,
        snowZH: 0
      },
      {
        year: 1991,
        day: 25,
        snowZH: 0
      },
      {
        year: 1991,
        day: 26,
        snowZH: 0
      },
      {
        year: 1992,
        day: 24,
        snowZH: 0
      },
      {
        year: 1992,
        day: 25,
        snowZH: 0
      },
      {
        year: 1992,
        day: 26,
        snowZH: 0
      },
      {
        year: 1993,
        day: 24,
        snowZH: 0
      },
      {
        year: 1993,
        day: 25,
        snowZH: 6
      },
      {
        year: 1993,
        day: 26,
        snowZH: 9
      },
      {
        year: 1994,
        day: 24,
        snowZH: 2
      },
      {
        year: 1994,
        day: 25,
        snowZH: 2
      },
      {
        year: 1994,
        day: 26,
        snowZH: 0
      },
      {
        year: 1995,
        day: 24,
        snowZH: 0
      },
      {
        year: 1995,
        day: 25,
        snowZH: 0
      },
      {
        year: 1995,
        day: 26,
        snowZH: 5
      },
      {
        year: 1996,
        day: 24,
        snowZH: 0
      },
      {
        year: 1996,
        day: 25,
        snowZH: 0
      },
      {
        year: 1996,
        day: 26,
        snowZH: 0
      },
      {
        year: 1997,
        day: 24,
        snowZH: 0
      },
      {
        year: 1997,
        day: 25,
        snowZH: 0
      },
      {
        year: 1997,
        day: 26,
        snowZH: 0
      },
      {
        year: 1998,
        day: 24,
        snowZH: 0
      },
      {
        year: 1998,
        day: 25,
        snowZH: 2
      },
      {
        year: 1998,
        day: 26,
        snowZH: 0
      },
      {
        year: 1999,
        day: 24,
        snowZH: 3
      },
      {
        year: 1999,
        day: 25,
        snowZH: 0
      },
      {
        year: 1999,
        day: 26,
        snowZH: 0
      },
      {
        year: 2000,
        day: 24,
        snowZH: 0
      },
      {
        year: 2000,
        day: 25,
        snowZH: 0
      },
      {
        year: 2000,
        day: 26,
        snowZH: 0
      },
      {
        year: 2001,
        day: 24,
        snowZH: 9
      },
      {
        year: 2001,
        day: 25,
        snowZH: 8
      },
      {
        year: 2001,
        day: 26,
        snowZH: 6
      },
      {
        year: 2002,
        day: 24,
        snowZH: 0
      },
      {
        year: 2002,
        day: 25,
        snowZH: 0
      },
      {
        year: 2002,
        day: 26,
        snowZH: 0
      },
      {
        year: 2003,
        day: 24,
        snowZH: 2
      },
      {
        year: 2003,
        day: 25,
        snowZH: 2
      },
      {
        year: 2003,
        day: 26,
        snowZH: 2
      },
      {
        year: 2004,
        day: 24,
        snowZH: 0
      },
      {
        year: 2004,
        day: 25,
        snowZH: 0
      },
      {
        year: 2004,
        day: 26,
        snowZH: 0
      },
      {
        year: 2005,
        day: 24,
        snowZH: 0
      },
      {
        year: 2005,
        day: 25,
        snowZH: 0
      },
      {
        year: 2005,
        day: 26,
        snowZH: 0
      },
      {
        year: 2006,
        day: 24,
        snowZH: 0
      },
      {
        year: 2006,
        day: 25,
        snowZH: 0
      },
      {
        year: 2006,
        day: 26,
        snowZH: 0
      },
      {
        year: 2007,
        day: 24,
        snowZH: 0
      },
      {
        year: 2007,
        day: 25,
        snowZH: 0
      },
      {
        year: 2007,
        day: 26,
        snowZH: 0
      },
      {
        year: 2008,
        day: 24,
        snowZH: 0
      },
      {
        year: 2008,
        day: 25,
        snowZH: 1
      },
      {
        year: 2008,
        day: 26,
        snowZH: 0
      },
      {
        year: 2009,
        day: 24,
        snowZH: 0
      },
      {
        year: 2009,
        day: 25,
        snowZH: 0
      },
      {
        year: 2009,
        day: 26,
        snowZH: 0
      },
      {
        year: 2010,
        day: 24,
        snowZH: 0
      },
      {
        year: 2010,
        day: 25,
        snowZH: 13
      },
      {
        year: 2010,
        day: 26,
        snowZH: 15
      },
      {
        year: 2011,
        day: 24,
        snowZH: 0
      },
      {
        year: 2011,
        day: 25,
        snowZH: 0
      },
      {
        year: 2011,
        day: 26,
        snowZH: 0
      },
      {
        year: 2012,
        day: 24,
        snowZH: 0
      },
      {
        year: 2012,
        day: 25,
        snowZH: 0
      },
      {
        year: 2012,
        day: 26,
        snowZH: 0
      },
      {
        year: 2013,
        day: 24,
        snowZH: 0
      },
      {
        year: 2013,
        day: 25,
        snowZH: 0
      },
      {
        year: 2013,
        day: 26,
        snowZH: 0
      },
      {
        year: 2014,
        day: 24,
        snowZH: 0
      },
      {
        year: 2014,
        day: 25,
        snowZH: 0
      },
      {
        year: 2014,
        day: 26,
        snowZH: 0
      },
      {
        year: 2015,
        day: 24,
        snowZH: 0
      },
      {
        year: 2015,
        day: 25,
        snowZH: 0
      },
      {
        year: 2015,
        day: 26,
        snowZH: 0
      },
      {
        year: 2016,
        day: 24,
        snowZH: 0
      },
      {
        year: 2016,
        day: 25,
        snowZH: 0
      },
      {
        year: 2016,
        day: 26,
        snowZH: 0
      },
      {
        year: 2017,
        day: 24,
        snowZH: 0
      },
      {
        year: 2017,
        day: 25,
        snowZH: 0
      },
      {
        year: 2017,
        day: 26,
        snowZH: 0
      }
    ]
    return (
      <div className='index'>
        <Masthead articleId={ARTICLE_ID} additionalShares={ADDITIONAL_SHARES} />
        <ThemeSwitch />

        <header className='ui vertical very fitted segment' id='snowstorm'>
          <div className='ui container'>
            <div className='ui header'>
              <h1>Das Märli von weissen Weihnachten</h1>
              <h2>
                Auch dieses Jahr gibt es keine weissen Weihnachten im Flachland.
                Wer jetzt denkt, früher habe es an den Festtagen öfter Schnee
                gegeben, sollte sich diese Daten anschauen.
              </h2>
            </div>
          </div>
          <Branches />
        </header>
        <SnowStorm
          animationInterval={33}
          snowStick
          freezeOnBlur
          excludeMobile={false}
          flakesMax={256}
          flakesMaxActive={100}
          snowCharacter='•'
          snowColor='#fff'
          targetElement='snowstorm'
          useMeltEffect={false}
        />
        <div className='ui vertical segment'>
          <div className='ui text container'>
            <div className='ta metainfo'>
              <div className='ta author'>
                Marc Fehr und Marc Brupbacher, Interaktiv-Team
              </div>
              <div className='ta updated'>
                Aktualisiert am 22. Dezember 2017
              </div>
            </div>
          </div>
          <div className='ui ta text container'>
            <p>
              <strong>Lange ist es her:</strong> Richtig weisse Weihnachten gab
              es in Zürich zuletzt 2003. Immerhin ein bisschen Schnee gab es
              nochmals 2010. Seit nunmehr sieben Jahren ist es nun aber an allen
              drei Weihnachtstagen grün.
            </p>
          </div>
          <div className='ui left aligned forest text container'>
            <h4 className='small title'>
              Seit 1931 gab es in Zürich nur 20 Mal wirklich weisse Weihnachten
            </h4>
            <Trees dataSet={dataSet} />
          </div>
          <div className='ui ta text container'>
            <p>
              Ist der Klimawandel schuld daran, dass es so selten weisse
              Weihnachten gibt? Nein. Ein Blick in die Statistik zeigt, auch
              früher lag am 24., 25. oder 26. Dezember im Raum Zürich nicht
              öfter Schnee. Über die fast 90-jährige Messreihe ist kein
              eindeutiger Trend zu erkennen.{' '}
              <strong>
                So gab es die längste Phase von grünen Weihnachten von 1941 bis
                1949.
              </strong>
            </p>
            <p>
              Laut Meteo Schweiz liegt an der Station Zürich-Fluntern im
              Durchschnitt knapp jedes vierte Jahr an allen drei Weihnachtstagen
              Schnee. Besser sieht es aus, wenn man ausrechnet, wie oft es
              wenigstens an einem der drei Tage mindestens einen Zentimeter
              schneite: Dann steigt die Wahrscheinlichkeit auf gut 40 Prozent.
            </p>
            <p>
              Betrachtet man nur die vergangenen Jahre, zeichnet sich eine
              längere schneearme Phase ab. Durchgängig weisse Weihnachten gab es
              in Zürich zuletzt 2003 – in Bern letztmals 2008. Teilweise Schnee
              gab es in Zürich 2008 (25. Dezember) und 2010 (25./26. Dezember).
              Seit 1991 gab es aber nur zweimal (2001 und 2003) Schnee an allen
              drei Weihnachtstagen. Solch eine lange Phase mit so wenig Schnee
              an Weihnachten gab es in Zürich seit 1931 noch nie.
            </p>
            <iframe
              src='//datawrapper.dwcdn.net/hzeGw/2/'
              scrolling='no'
              frameBorder='0'
              allowTransparency='true'
              allowFullscreen='allowfullscreen'
              webkitAllowFullscreen='webkitallowfullscreen'
              mozAllowFullscreen='mozallowfullscreen'
              oaAllowFullscreen='oallowfullscreen'
              msAllowFullscreen='msallowfullscreen'
              width='100%'
              height='520'
              style={{
                height: window.outerWidth > 599 ? '510px' : '540px',
                margin: '15px 0 15px 0'
              }}
            />
            <p>
              Übrigens: Auf den ersten in London gedruckten Weihnachtskarten
              1843 suchte man Schnee noch vergeblich,{' '}
              <a
                href='http://blogs.ethz.ch/klimablog-archive/2009/12/22/herbstliche-weihnachten/'
                target='_blank'
              >
                schreibt der Schweizer Klima-Forscher Stefan Brönnimann
              </a>
              . Erst spätere Weihnachtskarten zeigten dann oft Schnee. Denn 1860
              fuhren die ersten Engländer über die Feiertage in die Schweizer
              Berge. Sie importierten die Idee von weissen Weihnachten ins
              Flachland. Heute schneit es selbst auf australischen
              Weihnachtskarten.
            </p>
          </div>
        </div>

        <Footer
          articleId={ARTICLE_ID}
          additionalShares={ADDITIONAL_SHARES}
          credits={[
            [
              'Idee, Text, Programmierung',
              'Marc Brupbacher und Marc Fehr, Interaktiv-Team'
            ],
            ['Quellen', 'Meteo Schweiz']
          ]}
        />
      </div>
    )
  }
}

export default hot('AppComponent')
